import { render, staticRenderFns } from "./GanttPopup.vue?vue&type=template&id=4d5bf3e4&scoped=true&"
import script from "./GanttPopup.vue?vue&type=script&lang=js&"
export * from "./GanttPopup.vue?vue&type=script&lang=js&"
import style0 from "./GanttPopup.vue?vue&type=style&index=0&id=4d5bf3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bf3e4",
  null
  
)

export default component.exports